module.exports = __webpack_public_path__ + "static/media/seeMoreIcon.a6d59ada.svg";